/**
 * Table names for the Nostos v3 external API (`Query.NostosExternal.getData`).
 *
 * Tables are addressed by name — the registry's catalog_table without its schema
 * prefix — resolved server-side against the table registry of the environment
 * serving the request. Registry *ids* are allocated independently per environment
 * (the same integer points at unrelated tables in dev/staging vs prod), so tables
 * must never be addressed by hardcoded id from the client.
 */
export const NOSTOS_EXTERNAL_TABLES = {
  article_listicles: 'article_listicles',
  portfolio_projects: 'portfolio_projects',
  portfolio_projects_by_slug: 'portfolio_projects_by_slug',
  megamenu_popular_terms_by_domain: 'megamenu_popular_terms_by_domain',
  megamenu_nostos_job: 'megamenu_nostos_job',
  mix_and_match_s12n_ranking: 'mix_and_match_s12n_ranking',
  enterprise_products_with_labs: 'enterprise_products_with_labs',
  browse_relevant_skills_by_domain: 'browse_relevant_skills_by_domain',
  product_metrics: 'product_metrics',
  prod_search_queries_to_entities: 'prod_search_queries_to_entities',
  articles_estimated_read_time: 'articles_estimated_read_time',
  recent_pathway_completers: 'recent_pathway_completers',
} as const;

export type NostosExternalTable = keyof typeof NOSTOS_EXTERNAL_TABLES;
